import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home/Home.vue'
import Cart from '../components/Cart/Cart.vue'
import Signin from '../components/Signin/Signin.vue'
import Account from '../components/Account/Account.vue'
import Input from '../components/Input/Input.vue'
import Contact from '../components/Contact/Contact.vue'
import Success from '../components/Success/Success.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: 'Home - Retailers' }
  }, {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: { title: 'Cart - Retailers' }
  }, {
    path: '/',
    name: 'Signin',
    component: Signin,
    meta: { title: 'Sign in - Retailers' }
  }, {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: { title: 'Account - Retailers' }
  }, {
    path: '/input',
    name: 'Input',
    component: Input,
    meta: { title: 'Input - Retailers' }
  }, {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: { title: 'Contact - Retailers' }
  }, {
    path: '/success',
    name: 'Success',
    component: Success,
    meta: { title: 'Success - Retailers' }
  }
]

const router = new VueRouter({
  routes
})

export default router
